import {
  buildCreateField,
  buildTourAudioPayload,
  buildTourPromoVideoPayload,
  buildUpdateField,
} from "@utils/tours/tourFormHelpers";

export function buildTourSavePayload(draft, activeIsos) {
  const {
    countryId,
    countryName,
    cityId,
    cityName,
    tourId,
    buttonTitle: buttonTitleByLang,
    buttonTitleTranslationIds,
    badgeTitle: badgeTitleByLang,
    badgeTitleTranslationIds,
    name: nameByLang,
    nameTranslationIds,
    description: descriptionByLang,
    descriptionTranslationIds,
    duration: durationByLang,
    durationTranslationIds,
    country: countryByLang,
    countryTranslationIds,
    region: regionByLang,
    regionTranslationIds,
    city: cityByLang,
    cityTranslationIds,
    pointCount,
    stopCount,
    status,
    isActive,
    inclusiveAccessType,
    multimedia,
    banner,
    snapshot,
  } = draft;
  const basePayload = {
    countryId,
    countryName,
    cityId,
    cityName,
    buttonTitle: tourId
      ? buildUpdateField(buttonTitleByLang, buttonTitleTranslationIds, activeIsos)
      : buildCreateField(buttonTitleByLang, activeIsos),
    badgeTitle: tourId
      ? buildUpdateField(badgeTitleByLang, badgeTitleTranslationIds, activeIsos)
      : buildCreateField(badgeTitleByLang, activeIsos),
    point_count: Number(pointCount) || 0,
    stop_count: Number(stopCount) || 0,
    status,
    isActive,
    InclussiveAccessType: inclusiveAccessType,
    tourImages: (multimedia || [])
      .filter((item) => {
        const mediaType = String(item?.mediaType || "").toLowerCase();
        const mimeType = String(item?.mimeType || "").toLowerCase();
        return mediaType === "image" || mimeType.startsWith("image/");
      })
      .map((item) => item.id)
      .filter((id) => Boolean(id) && id !== banner?.id),
    banner: banner?.id,
    snapshot: snapshot?.id,
    tourPromoVideo: buildTourPromoVideoPayload(multimedia, activeIsos),
    tourAudio: buildTourAudioPayload(multimedia, activeIsos),
  };

  return tourId
    ? {
        ...basePayload,
        name: buildUpdateField(nameByLang, nameTranslationIds, activeIsos),
        description: buildUpdateField(
          descriptionByLang,
          descriptionTranslationIds,
          activeIsos,
        ),
        duration: buildUpdateField(
          durationByLang,
          durationTranslationIds,
          activeIsos,
        ),
        country: buildUpdateField(
          countryByLang,
          countryTranslationIds,
          activeIsos,
        ),
        region: buildUpdateField(
          regionByLang,
          regionTranslationIds,
          activeIsos,
        ),
        city: buildUpdateField(cityByLang, cityTranslationIds, activeIsos),
      }
    : {
        ...basePayload,
        name: buildCreateField(nameByLang, activeIsos),
        description: buildCreateField(descriptionByLang, activeIsos),
        duration: buildCreateField(durationByLang, activeIsos),
        country: buildCreateField(countryByLang, activeIsos),
        region: buildCreateField(regionByLang, activeIsos),
        city: buildCreateField(cityByLang, activeIsos),
      };
}
